import React from 'react'
import Parallax from '../Parallax'

function Erreur404() {
  return (
    <Parallax image="groseille.jpg" alt="Erreur 404" title="Erreur 404" />
  )
}

export default Erreur404